import classNames from "classnames";
import React, { MouseEventHandler } from "react";

type ButtonType = {
  label: string;
  action: MouseEventHandler<HTMLButtonElement>;
  isActive?: boolean;
  disabled?: boolean;
};

type Props = { buttons: ButtonType[] };

export const GroupButtons: React.FC<Props> = ({ buttons }) => {
  return (
    <div className={"flex rounded-lg border border-[#E4E9F2] p-1 font-medium"}>
      {buttons.map((item) => (
        <button
          key={item.label}
          disabled={item.disabled}
          className={classNames(
            "rounded-md px-3 py-1.5 text-sm transition-all duration-300 disabled:cursor-not-allowed",
            item.isActive ? "bg-[#7A5AF81A] text-[#6938EF]" : "text-[#3F5266]",
          )}
          onClick={item.action}>
          {item.label}
        </button>
      ))}
    </div>
  );
};
